import axios, { AxiosResponse } from 'axios';
import DataAccountDetails from 'models/data-account-details.model';
import DataEmail from 'models/data-email.model';
import DataPasswordUpdate from 'models/data-password-update.model';
import { UserProfile } from 'models/user-profile.model';
import { SignInType } from './auth.service';

const apiUrlPath = 'user';

export const getUserProfile = (
  signInType: SignInType,
): Promise<AxiosResponse<UserProfile | any>> => {
  return signInType === SignInType.USER
    ? axios.get(`${apiUrlPath}/profile`)
    : axios.get(`bike/partner/profile`);
};

export const updateProfileDetails = (
  email: string,
  userDetails: DataAccountDetails,
): Promise<AxiosResponse<UserProfile>> => {
  return axios.patch(`${apiUrlPath}/update/${email}`, userDetails);
};

export const updatePasswordDetails = (
  email: string,
  passwordDetails: DataPasswordUpdate,
  isSecurity: boolean,
): Promise<AxiosResponse<UserProfile>> => {
  const body = { ...passwordDetails, isSecurity };
  return axios.patch(`${apiUrlPath}/update/${email}`, body);
};

export const emailCheck = (
  userData: DataEmail,
): Promise<AxiosResponse<{ data: { email: string } }>> => {
  return axios.get(`${apiUrlPath}/${userData.email}`);
};
